

//add profile photo

export const ADD_PROFILEPHOTO_START = "ADD_PROFILEPHOTO_START";
export const ADD_PROFILEPHOTO_SUCCESS = "ADD_PROFILEPHOTO_SUCCESS";
export const ADD_PROFILEPHOTO_FAILURE = "ADD_PROFILEPHOTO_FAILURE";
export const ADD_PROFILEPHOTO_RESET = "ADD_PROFILEPHOTO_RESET";